import { IStyleSettings } from "@nsdefs";

export const defaultStyles: IStyleSettings = {
  lineHeight: 1.5,
  fontFamily:
    "Lucida Console, Lucida Sans Unicode, Fira Mono, Consolas, Courier New, Courier, monospace, Times New Roman",
};
